import Insights from '../components/marketplace-account/my-solutions/solution-management/panels/Insights';
import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';

const getInsightDetails = gql`
  query($solutionId: ID, $status: String) {
    publishedReviewsForUser(filter: { solutionId: $solutionId }) {
      reviews {
        id
        status
        listingVersion
        solutionVersion
      }
      pageInfo {
        offset
      }
    }
    solutionLeads(filter: { solutionId: $solutionId }) {
      leads {
        solutionVersion
        listingVersion
      }
      pageInfo {
        offset
      }
    }
    listPlatformSubscriptions(
      solutionId: $solutionId
      status: $status
      pageSize: 0
    ) {
      totalItems
    }
  }
`;

const mapDataToProps = ({ data }) => ({
  reviews:
    data.publishedReviewsForUser && data.publishedReviewsForUser.reviews
      ? data.publishedReviewsForUser.reviews
      : [],
  leads:
    data.solutionLeads && data.solutionLeads.leads
      ? data.solutionLeads.leads
      : [],
  subscriptionCount: data.listPlatformSubscriptions
    ? data.listPlatformSubscriptions.totalItems
    : 0,
  loading: data.loading
});

export default compose(
  graphql(getInsightDetails, {
    props: mapDataToProps,
    options: ({ solutionId }) => ({
      variables: {
        solutionId,
        status: 'active'
      }
    })
  })
)(Insights);
